var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5127 16.6816V4.68164H19.5127V6.68347H21.5127V3.69164C21.5127 3.13386 21.0605 2.68164 20.5027 2.68164H2.5227C1.96493 2.68164 1.5127 3.13379 1.5127 3.69164V17.6716C1.5127 18.2294 1.96486 18.6816 2.5227 18.6816H5.86237L6.9654 16.6816H3.5127Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5127 9.18164H11.1018L9.99874 11.1816H5.5127V9.18164Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5127 12.6816H9.17146L8.06843 14.6816H5.5127V12.6816Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4725 11.2404L21.5127 11.1813V11.2404H21.4725Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2513 8.68347C13.8865 8.68347 13.5508 8.88188 13.3748 9.20105L9.24059 16.6971C8.87301 17.3636 9.35449 18.1815 10.1171 18.1815H13.7676V22.0802C13.7676 23.0093 14.9238 23.4375 15.5288 22.7315L22.2454 14.8927C22.802 14.2432 22.3402 13.2404 21.4853 13.2404H17.6917L19.7286 10.2477C20.1809 9.58305 19.7048 8.68347 18.901 8.68347H14.2513ZM11.8089 16.1815L14.8412 10.6835H17.0127L14.9758 13.6762C14.5237 14.3405 14.9993 15.2404 15.8034 15.2404H19.3138L15.7676 19.3789V17.1825C15.7676 16.6298 15.3196 16.1815 14.7666 16.1815H11.8089Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/actions.800e786a4a7e6281e76ef68a866b1e8d.svg";
export { ForwardRef as ReactComponent };